import { render, staticRenderFns } from "./PreviewRoyaltyReport.vue?vue&type=template&id=5332fe56"
import script from "./PreviewRoyaltyReport.vue?vue&type=script&lang=js"
export * from "./PreviewRoyaltyReport.vue?vue&type=script&lang=js"
import style0 from "./PreviewRoyaltyReport.vue?vue&type=style&index=0&id=5332fe56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports